import { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Widget from "./pages/Widget";
import TransactionResult from "./pages/TransactionResult";
import TransactionFailed from "./pages/TransactionFailed";
import InvoiceWidget from "./pages/InvoiceWidget";
import InvoiceResult from "./pages/InvoiceResult";

function App() {
  return (
    <>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<Widget />} />
        <Route path="/report/:transactionId" element={<TransactionResult />} />
        <Route path="/transaction-failed" element={<TransactionFailed />} />
        <Route path="/payment-invoice" element={<InvoiceWidget />} />
        <Route path="/invoice-report/:id" element={<InvoiceResult />} />
      </Routes>
    </>
  );
}

export default App;
